var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAddIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27907",
    "data-name": "Group 27907",
    transform: "translate(17481 14168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_1_",
    "data-name": "plus (1)",
    transform: "translate(-17479 -14166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27890",
    "data-name": "Group 27890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27889",
    "data-name": "Group 27889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47277",
    "data-name": "Path 47277",
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,18.451A8.451,8.451,0,1,1,18.451,10,8.461,8.461,0,0,1,10,18.451Z",
    fill: "#00a1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27892",
    "data-name": "Group 27892",
    transform: "translate(5.352 5.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27891",
    "data-name": "Group 27891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47278",
    "data-name": "Path 47278",
    d: "M145.543,139.111h-3.1v-3.1a.775.775,0,1,0-1.549,0v3.1h-3.1a.775.775,0,0,0,0,1.549h3.1v3.1a.775.775,0,0,0,1.549,0v-3.1h3.1a.775.775,0,0,0,0-1.549Z",
    transform: "translate(-137.022 -135.238)",
    fill: "#00a1af"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAddIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_add_icon.87c09d2d53fe46bc18bbac2e116b7c8a.svg";